const Pagination = ({
	itemPerPage,
	totalItem,
	value,
	setCurrentPage,
	setValue,
	currentPage,
}) => {
	const pagination = [];
	for (let i = 1; i <= Math.ceil(totalItem / itemPerPage); i++) {
		pagination.push(i);
	}

	const handlePrev = () => {
		if (value === 0 || currentPage === 1) return;
		else {
			setValue((prev) => prev - 1);
			setCurrentPage((prev) => prev - 1);
		}
	};

	const handleNext = () => {
		if (value === pagination.length - 1 || currentPage === pagination.length)
			return;
		else {
			setValue((prev) => prev + 1);
			setCurrentPage((prev) => prev + 1);
		}
	};

	return (
		<nav className="mt-20 h-8 flex gap-10 items-center justify-center">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="currentColor"
				className={`bi bi-chevron-left h-5 w-10 font-bold cursor-pointer ${
					currentPage === 1 ? "text-label" : "text-logoRed"
				}`}
				viewBox="0 0 16 16"
				onClick={handlePrev}
			>
				<path
					fillRule="evenodd"
					d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
				/>
			</svg>
			<ul className="flex items-center gap-10">
				{pagination.map((page, index) => {
					return (
						<div key={page} className="h-full">
							<li
								className={`p-2 h-full font-bold text-sm text-center ${
									index === value ? "border-b-2 border-logoRed" : ""
								}`}
							>
								{page}
							</li>
						</div>
					);
				})}
			</ul>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="currentColor"
				className={`bi bi-chevron-right font-bold h-5 w-10 cursor-pointer ${
					currentPage === pagination.length ? "text-label" : "text-logoRed"
				}`}
				viewBox="0 0 16 16"
				onClick={handleNext}
			>
				<path
					fillRule="evenodd"
					d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
				/>
			</svg>
		</nav>
	);
};

export default Pagination;
